var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.card.attachments && _vm.card.attachments.length
    ? _c(
        "div",
        { staticClass: "my-2" },
        [
          _c("div", { staticClass: "header" }, [
            _c("i", { staticClass: "fas fa-paperclip" }),
            _vm._v(" "),
            _c("h5", { staticClass: "d-inline mx-2" }, [
              _vm._v(_vm._s(_vm.$t("txtAttachments")))
            ])
          ]),
          _vm._v(" "),
          _vm._l(_vm.card.attachments, function(attach) {
            return _c(
              "div",
              {
                key: attach.id,
                staticClass: "d-inline-block m-1",
                staticStyle: { width: "64px" },
                attrs: {
                  "data-placement": "top",
                  "data-toggle": "tooltip",
                  title: attach.fileName + "\n" + _vm.$t("kanbanAttachmentHelp")
                },
                on: {
                  contextmenu: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.onAttachmentClicked($event, attach)
                  }
                }
              },
              [
                _c(
                  "a",
                  { attrs: { href: "Files/DownloadFile/" + attach.mediaId } },
                  [
                    _c("img", {
                      staticClass: "mt-1",
                      attrs: {
                        src: "Files/PreviewFile/" + attach.mediaId,
                        height: "64"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { "max-width": "64px", overflow: "hidden" } },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "box-orient": "vertical",
                          display: "-webkit-box",
                          "line-clamp": "2",
                          "text-overflow": "ellipsis",
                          "word-break": "break-all"
                        }
                      },
                      [
                        _vm._v(
                          "\n        " + _vm._s(attach.fileName) + "\n      "
                        )
                      ]
                    )
                  ]
                )
              ]
            )
          }),
          _vm._v(" "),
          !_vm.readonly && !_vm.lockeddown
            ? _c("VueSimpleContextMenu", {
                ref: "attachmentContextMenu",
                attrs: {
                  elementId: "attchmentContextMenu" + _vm.card.id,
                  options: _vm.attachmentContextMenuOptions
                },
                on: { "option-clicked": _vm.onAttachmentContextMenuClicked }
              })
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }